<app-page class="small">
  <ng-template #head>
    <!-- <ng-container [ngTemplateOutlet]="expo_template"></ng-container> -->
    <ng-container [ngTemplateOutlet]="img0_template"></ng-container>
    <ng-container [ngTemplateOutlet]="img1_template"></ng-container>
    <ng-container [ngTemplateOutlet]="img2_template"></ng-container>
    <ng-container [ngTemplateOutlet]="img3_template"></ng-container>
  </ng-template>
</app-page>

<app-page class="medium">
  <ng-template #head>
    <!-- <ng-container [ngTemplateOutlet]="expo_template"></ng-container> -->
    <ng-container [ngTemplateOutlet]="img0_template"></ng-container>
  </ng-template>
  <ng-template #col1>
    <ng-container [ngTemplateOutlet]="img1_template"></ng-container>
    <ng-container [ngTemplateOutlet]="img3_template"></ng-container>
  </ng-template>
  <ng-template #col2>
    <ng-container [ngTemplateOutlet]="img2_template"></ng-container>
  </ng-template>
</app-page>

<app-page class="large">
  <ng-template #head>
    <!-- <ng-container [ngTemplateOutlet]="expo_template"></ng-container> -->
    <ng-container [ngTemplateOutlet]="img0_template"></ng-container>
    </ng-template>
  <ng-template #col1>
    <ng-container [ngTemplateOutlet]="img1_template"></ng-container>
  </ng-template>
  <ng-template #col2>
    <ng-container [ngTemplateOutlet]="img2_template"></ng-container>
  </ng-template>
  <ng-template #col3>
    <ng-container [ngTemplateOutlet]="img3_template"></ng-container>
  </ng-template>
</app-page>

<ng-template #expo_template>
  <app-card [content]="exposition"></app-card>
</ng-template>

<ng-template #img0_template>
  <app-card [content]="horizon"></app-card>
</ng-template>

<ng-template #img1_template>
  <app-card [content]="stream"></app-card>
</ng-template>

<ng-template #img2_template>
  <app-card [content]="chord"></app-card>
</ng-template>

<ng-template #img3_template>
  <app-card [content]="heatmap"></app-card>
</ng-template>

<!-- <ng-template #text_template>
  <app-card [content]="information"></app-card>
</ng-template> -->


